var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 3.5C11.876 3.49987 9.80179 4.14398 8.05136 5.34729C6.30093 6.55059 4.95661 8.2565 4.19592 10.2397C3.43522 12.223 3.29393 14.3903 3.79068 16.4556C4.28744 18.5208 5.39889 20.3868 6.97827 21.8072C7.63701 20.511 8.64173 19.4225 9.88112 18.6622C11.1205 17.902 12.5462 17.4997 14.0001 17.5C13.1349 17.5 12.289 17.2434 11.5695 16.7627C10.8501 16.2819 10.2893 15.5987 9.95818 14.7992C9.62704 13.9998 9.5404 13.1201 9.70921 12.2715C9.87802 11.4228 10.2947 10.6433 10.9066 10.0314C11.5184 9.41955 12.298 9.00287 13.1466 8.83406C13.9953 8.66525 14.875 8.75189 15.6744 9.08303C16.4738 9.41416 17.1571 9.97492 17.6378 10.6944C18.1186 11.4138 18.3751 12.2597 18.3751 13.125C18.3751 14.2853 17.9142 15.3981 17.0937 16.2186C16.2733 17.0391 15.1605 17.5 14.0001 17.5C15.454 17.4996 16.8796 17.9017 18.119 18.6618C19.3584 19.4218 20.3631 20.5101 21.022 21.8061C22.601 20.3856 23.7121 18.5197 24.2086 16.4547C24.7051 14.3896 24.5637 12.2226 23.8031 10.2396C23.0424 8.25654 21.6983 6.55082 19.9481 5.34757C18.198 4.14432 16.124 3.50012 14.0001 3.5Z",
    fill: "#283E24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97803 21.8061C7.63637 20.5094 8.64092 19.4203 9.88034 18.6595C11.1198 17.8987 12.5456 17.496 13.9999 17.496C15.4542 17.496 16.88 17.8987 18.1195 18.6595C19.3589 19.4203 20.3634 20.5094 21.0218 21.8061",
    stroke: "#283E24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.20101 19.799 3.5 14 3.5C8.20101 3.5 3.5 8.20101 3.5 14C3.5 19.799 8.20101 24.5 14 24.5Z",
    stroke: "#283E24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.5C16.4162 17.5 18.375 15.5412 18.375 13.125C18.375 10.7088 16.4162 8.75 14 8.75C11.5838 8.75 9.625 10.7088 9.625 13.125C9.625 15.5412 11.5838 17.5 14 17.5Z",
    stroke: "#283E24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/UserCircle.0c00b164c669156fb2be5830b8dfc1c4.svg";
export { ForwardRef as ReactComponent };